import React from 'react';
import PropTypes from 'prop-types';
import css from './FilterButton.module.css';

const FilterButton = ({ className, label = 'Filters', type = 'button', ...rest }) => {
  const classes = [css.filterButton, className].filter(Boolean).join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      <svg
        className={css.filterIcon}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" fill="currentColor" />
      </svg>
      <span className={css.filterButtonText}>{label}</span>
    </button>
  );
};

FilterButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
};

export default FilterButton;
